import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

// The API's maintenance message names the product. The old name stays accepted until every API host sends only the new one.
export const MAINTENANCE_MESSAGES: readonly string[] = ['Cintra Cloud', 'Cintra People'].map(
  (productName) => `${productName} is currently undergoing essential maintenance`
);

@Injectable()
export class UnderMaintenanceInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 503 && MAINTENANCE_MESSAGES.includes(error.error?.message)) {
          this.router.navigateByUrl('/under-maintenance').then();
          return EMPTY;
        }
        return throwError(() => error);
      })
    ) as Observable<HttpEvent<any>>;
  }
}
